import React from 'react'
import './Footer.css'

const Footer = () => {

return (
    <footer className="footer" id="footer">
 portfolio &copy; 2022 - All Rights Reserved by   <strong>_ Rohit Barate </strong>
    </footer>
)

}

export default Footer